<app-bottom-sheet #sheet ariaLabelledBy="other-wallets-title" footerClass="pt-3 pb-4">
	<ng-template #header>
		<h2 id="other-wallets-title" class="w-full text-center text-sm font-bold text-gray-900">
			سایر کیف‌پول‌های بورس کالا
		</h2>
	</ng-template>

	<ng-template #body>
		<dl
			class="mt-3 flex flex-col gap-2 rounded-xl border border-stroke-050 p-3 text-3.25 text-gray-900"
			data-cy="other-wallets-list">
			@for (wallet of wallets(); track wallet.key) {
				<div class="flex items-center justify-between gap-3" [attr.data-cy]="'other-wallet-' + wallet.key">
					<dt class="font-medium">{{ wallet.title }}</dt>
					<dd class="flex items-center gap-1">
						@if (amountsHidden()) {
							<span class="tracking-widest">{{ maskedValue }}</span>
						} @else {
							<ui-number format="1.0-0" dir="ltr" class="tabular-nums" [value]="wallet.balance" />
						}
						<span>ریالءء</span>
					</dd>
				</div>
			}
		</dl>
	</ng-template>

	<ng-template #footer>
		<ui-button
			class="w-full"
			extraButtonClasses="w-full"
			variant="mute"
			size="lg"
			data-cy="other-wallets-close"
			(clicked)="close()">
			بستن
		</ui-button>
	</ng-template>
</app-bottom-sheet>
